import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  commonImport({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/aiBaseData/commonImportExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  commonExport({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/aiBaseData/commonExportExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  selectMainListData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/aiBaseData/selectMainListData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
